module.exports = __webpack_public_path__ + "img/arrow4.6173aba8.png";